let api_base_url = null;
let ecom_url = null;
if (process.env.REACT_APP_ENV == "production") {
  api_base_url = process.env.REACT_APP_API_BASE_URL_PRODUCTION;
  ecom_url = process.env.REACT_APP_ECOM_URL_PRODUCTION
} else if (process.env.REACT_APP_ENV == "beta") {
  api_base_url = process.env.REACT_APP_API_BASE_URL_BETA;
}else if (process.env.REACT_APP_ENV == "pre_prod" || process.env.REACT_APP_ENV == "auto-scalling") {
  api_base_url = process.env.REACT_APP_API_BASE_URL_PRE_PROD;
  ecom_url = process.env.REACT_APP_ECOM_URL_PRE_PROD
} else if (process.env.REACT_APP_ENV == "staging") {
  api_base_url = process.env.REACT_APP_API_BASE_URL_STAGING;
  ecom_url = process.env.REACT_APP_ECOM_URL_STAGING
} else {
  // api_base_url = process.env.REACT_APP_API_BASE_URL_DEVELOPMENT;
  api_base_url = 'https://innocom-api.innofast.tech/api/v1';
  ecom_url = process.env.REACT_APP_ECOM_URL_STAGING
}
export const API_BASE_URL = `${api_base_url}`;
export const ECOM_URL = `${ecom_url}`;
export const DEBOUNCE_TIME = 500;
